module.exports = __webpack_public_path__ + "static/media/white-corelogic-logo.74ecee6d.svg";